import { getErrorMessage } from "../../../../../helper/getResponseMessage";
import axios from "../../../../../util/axiosconfig";
import { SORT_FILTER } from "../../../../../util/constants";
import { showError, showSuccess } from "../../../../../util/ShowStatus";
import { ROLES } from "../../../../../util/roleNameConstants";

export const fetchTeamLogsData = async (props: any) => {
  try {
    props.setTeamLogsDataLoading(true);
    const params: any = {
      sortField: `${props.isWorkerView ? "displayName" : "registration_no"} , ${
        props.sortFilter.sortField
      }`,
      sortOrder:
        props.sortFilter.sortOrder === true
          ? SORT_FILTER.ASC
          : SORT_FILTER.DESC,
    };
    if (props.filters) {
      params.startDate = props.filters.startDate;
      params.endDate = props.filters.endDate;
      params.vehicleID = props.filters?.vehicleRegistration?.vehicleID;
      props.filters.name !== "" && (params.displayName = props.filters.name);
      props.filters.status && (params.status = props.filters.status);
      props.filters.project &&
        (params.projectID = props.filters.project.projectID);

      const response = await axios.get("tl-user/team-logs-list", { params });
      let isExportDisabled = true;
      if (Array.isArray(response.data.result)) {
        isExportDisabled = !response.data.result.some(
          (log: any) => log.status === "APPROVED"
        );
      }
      props.setIsExportDisabled(isExportDisabled);
      props.setTeamLogsData(response.data.result);
      props.setTeamLogsDataLoading(false);
    }
  } catch (err) {
    const error = getErrorMessage(err);
    props.setTeamLogsDataLoading(false);
    showError(error, props.toast);
  }
};

export const fetchVehicles = async (
  setVehiclesList: any,
  setVehicleListLoading: any,
  toast: any
) => {
  try {
    setVehicleListLoading(true);
    const response = await axios.get("tl-admin/vehicle/all?page=-1");
    if (Array.isArray(response.data.result)) {
      response.data.result.sort((a: any, b: any) => {
        if (a.registration_no === "No Vehicle") return -1;
        if (b.registration_no === "No Vehicle") return 1;
        return 0;
      });
    }
    setVehiclesList(response.data.result);
    setVehicleListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setVehicleListLoading(false);
    showError(error, toast);
  }
};

export const fetchProjects = async (
  setProjectsList: any,
  setProjectListLoading: any,
  toast: any
) => {
  try {
    setProjectListLoading(true);
    const response = await axios.get("tl-admin/project/all?page=-1");
    setProjectsList(response.data.result);
    setProjectListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setProjectListLoading(false);
    showError(error, toast);
  }
};

export const updateVehicle = async (
  selectedVehicle: any,
  toast: any,
  setTeamLogsDataLoading: any,
  setEditVehicleRowIndex: any
) => {
  try {
    const params: any = {};
    setTeamLogsDataLoading(true);
    if (selectedVehicle) {
      params.timeLogID = selectedVehicle.timeLogID;
      params.log_date = selectedVehicle.log_date.toString();
      params.userID = selectedVehicle.userID;
      params.vehicleID = selectedVehicle.vehicleID;
    }
    const response = await axios.post(`tl-user/update-vehicle`, params);
    showSuccess(response.data.message, toast);
    setEditVehicleRowIndex(null);
    setTeamLogsDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setTeamLogsDataLoading(false);
    showError(error, toast);
  }
};

export const addTrackerTime = async (
  addTrackerTimeData: any,
  timeLogID: any,
  toast: any,
  setTeamLogsDataLoading: any,
  setEditTrackerTimeRowIndex: any,
  rowData: any,
  hideAdminComments: boolean,
  hideManagerComments: boolean,
  type?: any
) => {
  try {
    setTeamLogsDataLoading(true);
    const params: any = {};
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let trackerStartUTC: any = null;
    let trackerEndUTC: any = null;
    if (
      type &&
      type === "addTrackerTime" &&
      addTrackerTimeData.tracker_duration
    ) {
      const [hours, minutes, seconds] = rowData.duration.split(":").map(Number);
      const [trackerHours, trackerMinutes, trackerSeconds] =
        addTrackerTimeData.tracker_duration.split(":").map(Number);

      // Convert Unix timestamp (seconds or milliseconds) to UTC string
      if (addTrackerTimeData.tracker_start) {
        // If tracker_start is in seconds, multiply by 1000 to get milliseconds
        const timestamp = Number(addTrackerTimeData.tracker_start) * 1000;
        trackerStartUTC = new Date(timestamp);
        trackerStartUTC = Math.floor(new Date(timestamp).getTime() / 1000);
      }

      if (addTrackerTimeData.tracker_end) {
        // If tracker_end is in seconds, multiply by 1000 to get milliseconds
        const timestamp = Number(addTrackerTimeData.tracker_end) * 1000;
        trackerEndUTC = new Date(timestamp);
        trackerEndUTC = Math.floor(new Date(timestamp).getTime() / 1000);
      }

      const rowDataDurationInMinutes = hours * 60 + minutes;
      const trackerDurationInMinutes = trackerHours * 60 + trackerMinutes;
      if (Math.abs(rowDataDurationInMinutes - trackerDurationInMinutes) > 15) {
        params.isLogTimeMisMatch = true;
      }
    }
    if (rowData && rowData.isLogTimeMisMatch && type === "addAdminComment") {
      params.isLogTimeMisMatch = rowData.isLogTimeMisMatch === 1 ? true : false;
    }
    if (timeLogID) {
      params.timeLogID = timeLogID;
    }
    if (addTrackerTimeData.tracker_start) {
      params.tracker_start = trackerStartUTC.toString();
    }
    if (addTrackerTimeData.tracker_end) {
      params.tracker_end = trackerEndUTC.toString();
    }
    if (addTrackerTimeData.tracker_duration) {
      params.tracker_duration = addTrackerTimeData.tracker_duration;
    }

    // Check user roles to determine which comments to send
    const isTimelogHR =
      localStorage.roleName && localStorage.roleName.includes(ROLES.TIMELOG_HR);
    const isTimelogAdmin =
      localStorage.roleName &&
      localStorage.roleName.includes(ROLES.TIMELOG_ADMIN);

    if (addTrackerTimeData.admin_comment) {
      // If user is HR only, send as hr_comment
      if (isTimelogHR && !isTimelogAdmin) {
        params.hrHideComment = hideAdminComments;
        params.hr_comment = addTrackerTimeData.admin_comment.trim();
      }
      // If user is Admin only, send as admin_comment
      else if (isTimelogAdmin && !isTimelogHR) {
        params.adminHideComment = hideAdminComments;
        params.admin_comment = addTrackerTimeData.admin_comment.trim();
      }
      // If user has both roles, send both
      else if (isTimelogAdmin && isTimelogHR) {
        params.adminHideComment = hideAdminComments;
        params.admin_comment = addTrackerTimeData.admin_comment.trim();
        params.hrHideComment = hideAdminComments;
        params.hr_comment = addTrackerTimeData.admin_comment.trim();
      }
      // Fallback: send as admin_comment
      else {
        params.adminHideComment = hideAdminComments;
        params.admin_comment = addTrackerTimeData.admin_comment.trim();
      }
    }

    if (addTrackerTimeData.isLogTimeMisMatch) {
      params.isLogTimeMisMatch = addTrackerTimeData.isLogTimeMisMatch;
    }
    const response = await axios.post("tl-user/add-tracker", params);
    showSuccess(response.data.message, toast);
    setEditTrackerTimeRowIndex(null);
    setTeamLogsDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setTeamLogsDataLoading(false);
    showError(error, toast);
  }
};

export const approveTimeLog = async (
  timeLogID: any,
  managerComments: any,
  hideManagerComments: any,
  toast: any,
  setTeamLogsDataLoading: any
) => {
  try {
    const params: any = {};
    params.timeLogID = [timeLogID];
    if (managerComments) {
      params.managerHideComment = hideManagerComments;
      params.manager_comment = managerComments;
    }
    setTeamLogsDataLoading(true);
    const response = await axios.post(`tl-user/add-manager-comment`, params);
    showSuccess(response.data.message, toast);
    setTeamLogsDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setTeamLogsDataLoading(false);
    showError(error, toast);
  }
};

export const approveTimelogByHR = async (
  timeLogID: any,
  status: any,
  setIsHRApproving: any,
  toast: any,
  approvedTimeType?: string,
  hrComment?: string
) => {
  try {
    setIsHRApproving(true);
    const params: any = {};
    if (timeLogID) {
      params.timeLogID = timeLogID;
    }
    if (status) {
      params.status = status;
    }
    if (approvedTimeType && status === "APPROVED") {
      params.approvedTimeType = approvedTimeType;
    }
    if (hrComment) {
      params.hr_comment = hrComment;
    }
    const response = await axios.post(`tl-user/update-timelog-status`, params);
    setIsHRApproving(false);
    showSuccess(response.data.message, toast);
  } catch (err) {
    const error = getErrorMessage(err);
    setIsHRApproving(false);
    showError(error, toast);
  }
};

export const rejectTimeLog = async (
  rowData: any,
  selectedProjectArray: any[],
  selectedAppTimeDataArray: any[],
  managerTimeData: any,
  toast: any,
  managerComments: string,
  setTeamLogsDataLoading: (loading: boolean) => void,
  hideManagerComments?: boolean
) => {
  try {
    // Build timeLogDetails from selectedAppTimeDataArray or from rowData.timelogdetails
    let timeLogDetailsArray: any[] = [];

    if (selectedAppTimeDataArray.length > 0) {
      // If app times were edited, use selectedAppTimeDataArray
      timeLogDetailsArray = selectedAppTimeDataArray.map((timeData) => {
        const project = selectedProjectArray.find(
          (proj) =>
            proj.timelogdetailsID.toString() ===
            timeData.timelogdetailsID.toString()
        );

        return {
          timelogdetailsID: timeData.timelogdetailsID,
          projectID: project?.projectID || timeData.projectID,
          punch_in: timeData.start_time || null,
          punch_out: timeData.end_time || null,
          userID: timeData.userID,
          duration: timeData.duration || null,
        };
      });
    } else if (rowData?.timelogdetails && rowData.timelogdetails.length > 0) {
      // If no app time edits, use original timelogdetails
      timeLogDetailsArray = rowData.timelogdetails.map((detail: any) => {
        const project = selectedProjectArray.find(
          (proj) =>
            proj.timelogdetailsID.toString() ===
            detail.timelogdetailsID.toString()
        );

        return {
          timelogdetailsID: detail.timelogdetailsID,
          projectID: project?.projectID || detail.projectID,
          punch_in: detail.start_time || null,
          punch_out: detail.end_time || null,
          userID: detail.userID,
          duration: detail.duration || null,
        };
      });
    }

    const params: any = {
      timeLogID: selectedAppTimeDataArray.length
        ? selectedAppTimeDataArray[0].timeLogID
        : rowData?.timeLogID,
      timeLogDetails: timeLogDetailsArray,
      manager_comment: managerComments.trim() || "",
      managerHideComment: hideManagerComments || false,
    };

    // Add single manager time at timelog level
    if (managerTimeData?.manager_start) {
      params.manager_punch_in = managerTimeData.manager_start;
    }
    if (managerTimeData?.manager_end) {
      params.manager_punch_out = managerTimeData.manager_end;
    }
    if (managerTimeData?.manager_duration) {
      params.manager_duration = managerTimeData.manager_duration;
    }

    setTeamLogsDataLoading(true);
    const response = await axios.post(`tl-user/reject-time-logs`, params);
    showSuccess(response.data.message, toast);
    setTeamLogsDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setTeamLogsDataLoading(false);
    showError(error, toast);
  }
};

export const updateProject = async (
  rowData: any,
  selectedProjectArray: any,
  toast: any,
  setTeamLogsDataLoading: any,
  setEditProjectIndices: any
) => {
  try {
    const params: any = {};
    setTeamLogsDataLoading(true);
    if (selectedProjectArray && selectedProjectArray.length !== 0) {
      params.projectUpdateDetails = selectedProjectArray;
    }
    const response = await axios.post(`tl-user/update-project-details`, params);
    showSuccess(response.data.message, toast);
    setEditProjectIndices([]);

    setTeamLogsDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setTeamLogsDataLoading(false);
    showError(error, toast);
  }
};
